import { Component, inject, signal } from '@angular/core';
import { BookingMenu, BookingRemoteMenu } from '@fry/booking/app';
import { GeneralMenu } from '@fry/components/general';
import { EportfolioMenu } from '@fry/components/general/eportfolio.menu';
import { RolesMenu } from '@fry/components/roles';
import { UsersFieldsMenu } from '@fry/components/user-fields';
import { UsersMenu, UsersRemoteMenu } from '@fry/components/users';
import { DashboardMenu } from '@fry/dashboards/lib/dashboard.menu';
import { AppLoadService } from '@fry/lib/appload/appload.service';
import { AuthService } from '@fry/lib/auth';
import { OidcService } from '@fry/lib/core';
import { MenuService, RemoteMenuService } from '@fry/lib/menu';
import { RemoteUserService } from '@fry/lib/users';
import { PaymentsMenu } from '@fry/payments/components';
import { map, Observable } from 'rxjs';
import { ConnectionsMenu } from "@fry/connections/app/connections.menu";

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    standalone: false
})
export class MainComponent {

  loaded = signal<boolean>(false);
  private auth = inject(AuthService);
  private remoteUserService = inject(RemoteUserService);
  private oidc = inject(OidcService);

  private menu = inject(MenuService);
  private appLoadService = inject(AppLoadService);
  organisation$!: Observable<string>;

  private remoteMenu = inject(RemoteMenuService);
  private usersMenu = inject(UsersMenu);
  private usersRemoteMenu = inject(UsersRemoteMenu);
  private userFields = inject(UsersFieldsMenu);
  private roles = inject(RolesMenu);
  private dashboard = inject(DashboardMenu);
  private booking = inject(BookingMenu);
  private bookingRemoteMenu = inject(BookingRemoteMenu);
  private epf = inject(EportfolioMenu);
  private general = inject(GeneralMenu);
  private payments = inject(PaymentsMenu);
  private connections = inject(ConnectionsMenu);

  async ngOnInit() {
    if (!this.oidc.isLoggedIn) {
      await this.oidc.renewToken();
    }
    await this.appLoadService.initializeApp();
    this.registerMenus();

    this.remoteUserService.startWatchingForRemoteUser();
    this.organisation$ = this.auth.currentUser().pipe(
      map(current => current.organisation)
    );

    this.loaded.set(true);

  }

  private registerMenus() {
    console.log('Registering features');
    this.menu.register(this.dashboard.routes);

    this.menu.register(this.booking.routes);
    this.remoteMenu.register(this.usersRemoteMenu.routes);
    this.remoteMenu.register(this.bookingRemoteMenu.routes);
    this.menu.register(this.payments.routes);
    this.menu.register(this.connections.routes);

    this.menu.register(this.usersMenu.routes);

    this.menu.register(this.userFields.routes);
    this.menu.register(this.roles.routes);
    this.menu.register(this.general.routes);
    this.menu.register(this.epf.routes);
  }
}
